import { render } from "./lines.vue?vue&type=template&id=000a8b54&scoped=true"
import script from "./lines.vue?vue&type=script&lang=js"
export * from "./lines.vue?vue&type=script&lang=js"

import "./lines.vue?vue&type=style&index=0&id=000a8b54&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000a8b54"]])

export default __exports__